import './SeoContainer.scss';

import { FC, useContext, useEffect, useState } from 'react';
import { AppContext } from 'components/AppContext/AppContext';
import { Col, Nav, Row, Tab } from 'react-bootstrap';

import ContentGraph from '../ContentGraph/ContentGraph';
import SeoSetup from '../SeoSetup/SeoSetup';
import TopicExplorer from '../TopicExplorer/TopicExplorer';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SeoContainerProps { }

const SeoContainer: FC<SeoContainerProps> = () => {
  const { setIsProjectSelectable } = useContext(AppContext);

  useEffect(() => {
    setIsProjectSelectable(true);
  }, []);

  const [activeTab, setActiveTab] = useState('setup');

  return (
    <div className="SeoContainer">
      <Tab.Container id="seo-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k!)}>
        <Row className="fit-to-screen">
          <Col sm={2} className='sidebar pt-2'>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="setup" className='sidebar-action'>
                  <i className='bi bi-gear-fill' />
                  <span className='route-name'>Setup</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="graph" className='sidebar-action'>
                  <i className='bi bi-diagram-2-fill' />
                  <span className='route-name'>Content Graph</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="topic-authority" className='sidebar-action'>
                  <i className='bi bi-diagram-3' />
                  <span className='route-name'>Topic Authority</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={10} className='pt-3 ps-3 pb-5'>
            <Tab.Content>
              <Tab.Pane eventKey="setup">
                <SeoSetup />
              </Tab.Pane>
              <Tab.Pane eventKey="graph">
                <ContentGraph activeTab={activeTab} />
              </Tab.Pane>
              <Tab.Pane eventKey="topic-authority">
                <TopicExplorer activeTab={activeTab} />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>

    </div>)
};

export default SeoContainer;
